import styled from 'styled-components';
import { Button } from 'reactstrap';

const MapButton = styled(Button)`
  background: #fff;
  color: #23272f;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 18px;
  padding: 0.35rem 0.6rem;
  font-size: 0.9rem;
  font-weight: 500;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: background 0.12s, transform 0.08s;
  pointer-events: auto;
  flex: 0 1 auto;
  min-width: 0;

  &:hover {
    background: #f3f6fa;
    border-color: #b3c2d1;
    box-shadow: 0 4px 12px 0 rgba(60, 100, 180, 0.1);
  }

  &:active {
    background: #e9eef5;
    border-color: #8fa4bf;
    box-shadow: 0 2px 6px 0 rgba(60, 100, 180, 0.08);
  }
`;

export default MapButton;
